import React from "react";
import CustomSelect from "../../globalcontrols/customselect/customselect";
import "./css/brandBreakdown.css";

const sourceMeta = {
  kakao: { label: "KAKAO", icon: "storefront", className: "kakao" },
  tablee: { label: "Tablee", icon: "shopping_bag", className: "tablee" },
  oliva: { label: "Oliva y Miel", icon: "spa", className: "oliva" },
};

const money = (value) => `$${Number(value || 0).toLocaleString("es-CL")}`;

function BrandBreakdown({ data, loading, error, selectedSource, setSelectedSource, embedded = false, showFilter = true }) {
  const options = [
    { value: "all", label: "Todas las marcas" },
    { value: "kakao", label: "KAKAO" },
    { value: "tablee", label: "Tablee" },
    { value: "oliva", label: "Oliva y Miel" },
  ];
  const allBrands = data?.brands || [];
  const brands = selectedSource === "all"
    ? allBrands
    : allBrands.filter((brand) => brand.source === selectedSource);
  const totalRevenue = Number(data?.totals?.collected_revenue || 0);
  const displayedTotals = selectedSource === "all"
    ? (data?.totals || {})
    : brands.reduce((total, brand) => ({
      collected_revenue: total.collected_revenue + Number(brand.collected_revenue || 0),
      pending_revenue: total.pending_revenue + Number(brand.pending_revenue || 0),
      transaction_count: total.transaction_count + Number(brand.transaction_count || 0),
    }), { collected_revenue: 0, pending_revenue: 0, transaction_count: 0 });

  const Wrapper = embedded ? "div" : "section";

  return (
    <Wrapper className={embedded ? "brand-breakdown" : "dashboard-card brand-card"} aria-labelledby="brand-breakdown-title">
      <div className="card-heading brand-heading">
        <div>
          <p className="card-kicker">Marcas internas</p>
          <h2 id="brand-breakdown-title">Ventas por negocio</h2>
        </div>
        {showFilter && <div className="brand-filter">
          <CustomSelect
            label="Fuente"
            options={options}
            selectedValue={selectedSource}
            onChange={setSelectedSource}
            labelExtractor={(item) => item.label}
            valueExtractor={(item) => item.value}
          />
        </div>}
      </div>

      {error && <div className="dashboard-alert" role="alert">{error}</div>}
      {loading ? (
        <div className="dashboard-loading" role="status">Consolidando marcas…</div>
      ) : (
        <>
          <div className="brand-totals">
            <div><span>Ingresos cobrados</span><strong>{money(displayedTotals.collected_revenue)}</strong></div>
            <div><span>Operaciones pagadas</span><strong>{Number(displayedTotals.transaction_count || 0).toLocaleString("es-CL")}</strong></div>
            <div><span>Ingresos pendientes</span><strong>{money(displayedTotals.pending_revenue)}</strong></div>
          </div>
          <div className="brand-list">
            {brands.map((brand) => {
              const meta = sourceMeta[brand.source];
              const share = totalRevenue > 0 ? (Number(brand.collected_revenue) / totalRevenue) * 100 : 0;
              return (
                <article className={`brand-row brand-${meta.className}`} key={brand.source}>
                  <span className="material-symbols-outlined brand-icon" aria-hidden="true">{meta.icon}</span>
                  <div className="brand-name">
                    <strong>{meta.label}</strong>
                    <span>{brand.transaction_count} operaciones · {share.toFixed(0)}% del total</span>
                  </div>
                  <div className="brand-value">
                    <strong>{money(brand.collected_revenue)}</strong>
                    {brand.pending_revenue > 0 && <span>{money(brand.pending_revenue)} pendiente</span>}
                  </div>
                  <div className="brand-progress" aria-label={`${meta.label}: ${share.toFixed(0)} por ciento`}>
                    <span style={{ width: `${Math.min(100, share)}%` }} />
                  </div>
                </article>
              );
            })}
          </div>
        </>
      )}
    </Wrapper>
  );
}

export default BrandBreakdown;
